import { useMemo } from 'react';
import { useDynamicForm } from '../../context';
import type { TDynamicFormField } from '../../types';
import { useStack } from '../FieldList';
import get from 'lodash/get';
import { formatValueDestination } from '../../../Validator';
import { getTaxTypeOptionsByCountryCode } from './helpers';
import { SelectField } from '../SelectField';
import type {
  GetUIElementByType,
  SELECT_FIELD_ELEMENT_TYPE,
  TAX_ID_PICKER_FIELD_ELEMENT_TYPE,
} from '@ballerine/common';

export type ITaxIdPickerFieldParams = {
  placeholder?: string;
  countryCodePath: string;
};

export const TaxIdPickerField: TDynamicFormField<
  GetUIElementByType<typeof TAX_ID_PICKER_FIELD_ELEMENT_TYPE>
> = ({ element }) => {
  const { countryCodePath } = element.params || {};
  const { values } = useDynamicForm();
  const { stack } = useStack();

  const countryCode = useMemo(() => {
    return get(values, formatValueDestination(countryCodePath || '', stack));
  }, [values, countryCodePath, stack]);

  const options = useMemo(
    () => (countryCode ? getTaxTypeOptionsByCountryCode(countryCode) : []),
    [countryCode, countryCodePath],
  );

  const elementWithStateOptions: GetUIElementByType<typeof SELECT_FIELD_ELEMENT_TYPE> =
    useMemo(() => {
      return {
        ...element,
        element: 'selectfield',
        params: {
          ...element.params,
          options,
        },
      };
    }, [element, options]);

  return <SelectField element={elementWithStateOptions} />;
};
